import { render, staticRenderFns } from "./BusinessSidebar.vue?vue&type=template&id=090f5ff0"
import script from "./BusinessSidebar.vue?vue&type=script&lang=js"
export * from "./BusinessSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports